//=require jquery.min.js
//=require html5shiv.min.js
//=require respond.min.js
//=require ../../../../../node_modules/bootstrap/dist/js/bootstrap.min.js
//=require ../../../../../node_modules/scrollreveal/dist/scrollreveal.min.js
//=require ../../../../../node_modules/owl.carousel/dist/owl.carousel.js
//=require ../../../../../node_modules/jquery-mask-plugin/dist/jquery.mask.min.js
//=require ../../../../../node_modules/selectric/src/jquery.selectric.js

$('select').selectric();

$('.owl-carousel').owlCarousel({
    loop: false,
    nav: true,
    items: 1,
    autoplay: true
});

$('.telefone').mask('(00)00000-0000');
$('.cep').mask('00000-000');
$('.data').mask('00/00/0000');

$(window).on('scroll', function () {
    if ($(window).scrollTop() > 350) {
        $(".menuFloat").addClass('ativo');
    } else if ($(window).scrollTop() < 350) {
        $(".menuFloat").removeClass('ativo');
    }
});

// $('.lnkCentral').on('click', function(){
//     $('html, body').animate({
//         scrollTop: $('#centralDoCliente').offset().top
//     }, 1000);
// });
$('.lnkWebmail').on('click', function(){
    $('html, body').animate({
        scrollTop: $('#webmail').offset().top
    }, 1000);
});

$('.botaoresponsivo').click(function() {
    $('.fullmenu').toggleClass('menumobile');
    $('.linhasmr').toggleClass('ativo');
    if ($('.linhasmr').hasClass('ativo')) {
        $(".linhasmr").addClass("ativo");
        $(".nav-collapse").addClass("in");
        $(".collapse").css({
            height: 'auto'
        });
    } else {
        $(".linhasmr").removeClass("ativo");
        $(".nav-collapse").removeClass("in");
        $(".collapse").css({
            height: '0'
        });
    }

    if ($('.fullmenu').hasClass('menumobile')) {
        $(".fullmenu").addClass("menumobile");
    } else {
        $(".fullmenu").removeClass("menumobile");
    }

    return false;
});

$('.fullmenu a').click(function(){
    $(".fullmenu").removeClass("menumobile");
    $(".linhasmr").removeClass("ativo");
    $(".nav-collapse").removeClass("in");
    $(".collapse").css({
        height: '0'
    });
});

if ($(window).width() > 1024) {
    window.sr = ScrollReveal({ reset: false });
    var fromtop = {
        origin: "top",
        distance: "200px",
        duration: 1500,
        scale: 0
    };
    var fromleft = {
        origin: "left",
        distance: "50%",
        duration: 1500,
        scale: 0,
        opacity: 1
    };
    var fromleft2 = {
        origin: "left",
        distance: "50%",
        duration: 2000,
        scale: 0,
        opacity: 1
    };
    var frombottom = {
        origin: "bottom",
        distance: "70%",
        duration: 2000,
        scale: 0
    };
    var fromright = {
        origin: "right",
        distance: "50%",
        duration: 1500,
        scale: 0,
        opacity: 1
    };
    var fromright2 = {
        origin: "right",
        distance: "50%",
        duration: 2000,
        scale: 0,
        opacity: 1
    };

    //GERAL REVEAL
    // sr.reveal('.fullmenu a', { duration: 1000 }, 50);
    // sr.reveal('.vitrine img', { duration: 1500 });
    // sr.reveal('.sobre .foto', fromleft);
    // sr.reveal('.sobre h1', fromright);
    // sr.reveal('.sobre .conteudo', fromright);
    // sr.reveal('.sobre .redes a', { duration: 1000 }, 50);
    // sr.reveal('.missao h1', frombottom);
    // sr.reveal('.missao .conteudo', frombottom);
    // sr.reveal('.ebook h1', fromleft);
    // sr.reveal('.ebook .conteudo', fromleft);
    // sr.reveal('.ebook img', fromtop);
    // sr.reveal('.clientes h1', fromtop);
    // sr.reveal('.clientes .cliente', { duration: 1000 }, 50);
    // sr.reveal('.contato h1', fromleft);
    // sr.reveal('.contato .formulario .form-group', { duration: 1000 }, 50);
    // sr.reveal('.contato .dados h1', frombottom);
    // sr.reveal('.contato .dados p', frombottom);
}

$('.abreModal').on('click', function(e) {
    e.preventDefault();
    var modal = $(this).data('modal');
    $('#modal' + modal).fadeIn();
});

$('.modal .table').on('click', function(e) {
    //e.preventDefault();
    var target = $(e.target);
    if (target.is('#modalBody') || target.parents().is('#modalBody')) return;
    $('html').removeClass('cutScroll');
    $('.modal').fadeOut();

});

$('.modal').on('click', '.close', function(e) {
    //e.preventDefault();
    $('html').removeClass('cutScroll');
    $('.modal').fadeOut();
});

/****************************** FUNCAO TESTA EMAIL **********************/
    
function IsEmail(email) {
    var exclude = /[^@\-\.\w]|^[_@\.\-]|[\._\-]{2}|[@\.]{2}|(@)[^@]*\1/;
    var check = /@[\w\-]+\./;
    var checkend = /\.[a-zA-Z]{2,3}$/;
    if (((email.search(exclude) != -1) || (email.search(check)) == -1) || (email.search(checkend) == -1)) {
        return false;
    } else {
        return true;
    }
}

/****************************** ENVIA FORM CONTATO **********************/

$("#formContato").submit(function(e) {
    e.preventDefault();

    $('#btnEnviarContato').html('<i class="fa fa-spinner fa-spin"></i> Aguarde. Enviando.');

    var nome = $("#nome").val();
    var email = $("#email").val();
    var telefone = $("#telefone").val();
    var assunto = $("#assunto").val();
    var mensagem = $("#mensagem").val();
    var erros = 0;

    if (nome == '') { $("#nome").addClass('errocampo'); erros++; } else { $("#nome").removeClass('errocampo'); }
    if (telefone == '') { $("#telefone").addClass('errocampo'); erros++; } else { $("#telefone").removeClass('errocampo'); }
    if (assunto == '') { $("#assunto").addClass('errocampo'); erros++; } else { $("#assunto").removeClass('errocampo'); }
    if (email == '' || !IsEmail(email)) { $("#email").addClass('errocampo'); erros++; } else { $("#email").removeClass('errocampo'); }
    if (mensagem == '') { $("#mensagem").addClass('errocampo'); erros++; } else { $("#mensagem").removeClass('errocampo'); }

    if (erros == 0) {
        $.post(url+'email/form_contato.php', $("#formContato").serialize(), function(data) {
            if (data == '1') {
                $(".erroContato").fadeOut('slow');
                $("#formContato")[0].reset();
                $(".sucessoContato").fadeIn('slow');
                $('#btnEnviarContato').html('Enviar');
            }
        });
    } else {
        $(".erroContato").fadeIn('slow');
        $('#btnEnviarContato').html('Enviar');
    }
});

$("#formLigamos").submit(function(e) {
    e.preventDefault();

    $('#btnEnviarLigamos').html('<i class="fa fa-spinner fa-spin"></i> Aguarde. Enviando.');

    var nome = $("#nomeLigamos").val();
    var telefone = $("#telefoneLigamos").val();
    var erros = 0;

    if (nome == '') { $("#nomeLigamos").addClass('errocampo'); erros++; } else { $("#nomeLigamos").removeClass('errocampo'); }
    if (telefone == '') { $("#telefoneLigamos").addClass('errocampo'); erros++; } else { $("#telefoneLigamos").removeClass('errocampo'); }

    if (erros == 0) {
        $.post(url+'email/form_ligamos.php', $("#formLigamos").serialize(), function(data) {
            if (data == '1') {
                $(".erroLigamos").fadeOut('slow');
                $("#formLigamos")[0].reset();
                $(".sucessoLigamos").fadeIn('slow');
                $('#btnEnviarLigamos').html('Enviar');
            }
        });
    } else {
        $(".erroLigamos").fadeIn('slow');
        $('#btnEnviarLigamos').html('Enviar');
    }
});

$("#formCadastro").submit(function(e) {
    e.preventDefault();

    let google = $('#g-recaptcha-response').val();

    if(google == '') {
        $(".erroCadastro").fadeIn('slow');
        $('#btnEnviarCadastro').html('Enviar');
    }
    else {
        $('#btnEnviarCadastro').html('<i class="fa fa-spinner fa-spin"></i> Aguarde. Enviando.');
        $.post(url+'email/form_cadastro.php', $("#formCadastro").serialize(), function(data) {
            if (data == '1') {
                $(".erroCadastro").fadeOut('slow');
                grecaptcha.reset();
                $("#formCadastro")[0].reset();
                $(".sucessoCadastro").fadeIn('slow');
                $('#btnEnviarCadastro').html('Enviar');
            } 
            else {
                $(".erroCadastro").fadeIn('slow');
                $('#btnEnviarCadastro').html('Enviar');
            }
        });
    }
});

function checkLogin($login) {
    $.post(url+'ajax/searchCliente.php', { login: $login }, function(data) {
        if (data == '2') {
            $('#chkLogin').removeClass('has-success');
            $('#chkLogin').addClass('has-error');
            $('#lblLoginCheck').html('<p class="text-danger">Login Indisponível</p>');
            $('#lblLoginCheck').fadeIn();
        } else {
            $('#chkLogin').removeClass('has-error');
            $('#chkLogin').addClass('has-success');
            $('#lblLoginCheck').html('<p class="text-success">Login Disponível</p>');
            $('#lblLoginCheck').fadeIn();
            setTimeout(function () {
                $('#lblLoginCheck').fadeOut();
            }, 3000);
        }
    });
}

let interval = null;

$('#login').on('keyup', function () {
    var login = $(this).val();

    if (interval) {
        clearTimeout(interval);
    }

    interval = setTimeout(function () {
        checkLogin(login);
    }, 300);

});

function limpa_formulário_cep() {
    // Limpa valores do formulário de cep.
    $("#endereco").val("");
    $("#bairro").val("");
    $("#cidade").val("");
    $("#uf").val("");
}

//Quando o campo cep perde o foco.
$("#cep").blur(function() {

    //Nova variável "cep" somente com dígitos.
    var cep = $(this).val().replace(/\D/g, '');

    //Verifica se campo cep possui valor informado.
    if (cep != "") {

        //Expressão regular para validar o CEP.
        var validacep = /^[0-9]{8}$/;

        //Valida o formato do CEP.
        if(validacep.test(cep)) {

            //Preenche os campos com "..." enquanto consulta webservice.
            $("#endereco").val("...");
            $("#bairro").val("...");
            $("#cidade").val("...");
            $("#estado").val("...");

            //Consulta o webservice viacep.com.br/
            $.getJSON("https://viacep.com.br/ws/"+ cep +"/json/?callback=?", function(dados) {

                if (!("erro" in dados)) {
                    //Atualiza os campos com os valores da consulta.
                    $("#endereco").val(dados.logradouro);
                    $("#bairro").val(dados.bairro);
                    $("#cidade").val(dados.localidade);
                    $("#estado").val(dados.uf);
                    $("#numero").focus();
                } //end if.
                else {
                    //CEP pesquisado não foi encontrado.
                    limpa_formulário_cep();
                    alert("CEP não encontrado.");
                }
            });
        } //end if.
        else {
            //cep é inválido.
            limpa_formulário_cep();
            alert("Formato de CEP inválido.");
        }
    } //end if.
    else {
        //cep sem valor, limpa formulário.
        limpa_formulário_cep();
    }
});

$("#formCorporativo").submit(function(e) {
    e.preventDefault();

    $('#btnEnviarCorporativo').html('<i class="fa fa-spinner fa-spin"></i> Aguarde. Enviando.');

    var nome = $("#nome").val();
    var email = $("#email").val();
    var telefone = $("#telefone").val();
    var assunto = $("#assunto").val();
    var mensagem = $("#mensagem").val();
    var erros = 0;

    if (nome == '') { $("#nome").addClass('errocampo'); erros++; } else { $("#nome").removeClass('errocampo'); }
    if (telefone == '') { $("#telefone").addClass('errocampo'); erros++; } else { $("#telefone").removeClass('errocampo'); }
    if (assunto == '') { $("#assunto").addClass('errocampo'); erros++; } else { $("#assunto").removeClass('errocampo'); }
    if (email == '' || !IsEmail(email)) { $("#email").addClass('errocampo'); erros++; } else { $("#email").removeClass('errocampo'); }
    if (mensagem == '') { $("#mensagem").addClass('errocampo'); erros++; } else { $("#mensagem").removeClass('errocampo'); }

    if (erros == 0) {
        $.post(url+'email/form_corporativo.php', $("#formCorporativo").serialize(), function(data) {
            if (data == '1') {
                $(".erroCorporativo").fadeOut('slow');
                $("#formCorporativo")[0].reset();
                $(".sucessoCorporativo").fadeIn('slow');
                $('#btnEnviarCorporativo').html('Enviar');
            }
        });
    } else {
        $(".erroCorporativo").fadeIn('slow');
        $('#btnEnviarCorporativo').html('Enviar');
    }
});

$("#formTrabalhe").submit(function(e) {
    e.preventDefault();

    $('#btnEnviarTrabalhe').html('<i class="fa fa-spinner fa-spin"></i> Aguarde. Enviando.');

    var nome = $("#nome").val();
    var email = $("#email").val();
    var telefone = $("#telefone").val();
    var mensagem = $("#mensagem").val();
    var erros = 0;

    if (nome == '') { $("#nome").addClass('errocampo'); erros++; } else { $("#nome").removeClass('errocampo'); }
    if (telefone == '') { $("#telefone").addClass('errocampo'); erros++; } else { $("#telefone").removeClass('errocampo'); }
    if (email == '' || !IsEmail(email)) { $("#email").addClass('errocampo'); erros++; } else { $("#email").removeClass('errocampo'); }
    if (mensagem == '') { $("#mensagem").addClass('errocampo'); erros++; } else { $("#mensagem").removeClass('errocampo'); }

    if (erros == 0) {

        var formData = new FormData();

        formData.append('nome', nome);
        formData.append("email", email);
        formData.append('telefone', telefone);
        formData.append("mensagem", mensagem);
        // Attach file
        formData.append('arquivo', $('input[type=file]')[0].files[0]);

        $.ajax({
            type: "POST",
            url: url+'email/form_trabalhe.php',
            enctype: 'multipart/form-data',
            data: formData,
            contentType: false, // NEEDED, DON'T OMIT THIS (requires jQuery 1.6+)
            processData: false, // NEEDED, DON'T OMIT THIS
            success: function (data) {
                console.log(data);
                $(".erroTrabalhe").fadeOut('slow');
                $("#formTrabalhe")[0].reset();
                $(".sucessoTrabalhe").fadeIn('slow');
                $('#btnEnviarTrabalhe').html('Enviar');
            }
        });
        // $.post(url+'email/form_contato.php', $("#formCorporativo").serialize(), function(data) {
        //     if (data == '1') {
        //         $(".erroTrabalhe").fadeOut('slow');
        //         $("#formTrabalhe")[0].reset();
        //         $(".sucessoTrabalhe").fadeIn('slow');
        //         $('#btnEnviarTrabalhe').html('Enviar');
        //     }
        // });
    } else {
        $(".erroTrabalhe").fadeIn('slow');
        $('#btnEnviarTrabalhe').html('Enviar');
    }
});